import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { Tutor } from '../models/tutor.model';

@Injectable({
    providedIn: 'root'
})
export class TutorService {

    private apiURL: string;
    private httpWithoutInterceptor: HttpClient;

    constructor(
        private http: HttpClient,
        private httpBackend: HttpBackend,
        private appConfigurationService: AppConfigurationService) {

            this.apiURL = this.appConfigurationService.baseApi + '/tutor';
            this.httpWithoutInterceptor = new HttpClient(httpBackend);

    }

    public get() {

        const url  = this.apiURL;
        return this.http.get<Tutor>(url);

    }

    public create(tutor: Tutor) {

        const url = this.apiURL;
        return this.httpWithoutInterceptor.post(url, tutor, { headers: new HttpHeaders(), responseType: 'text'}).pipe(
            map((response: string) => {
                return response;
            }),
            catchError((httpError: HttpErrorResponse) => {
                var error = this.handleHttpError(httpError);
                return throwError(error);
            })
        );

    }

    public update(tutor: Tutor) {

        const url = this.apiURL;
        return this.http.put<boolean>(url, JSON.stringify(tutor));

    }

    private handleHttpError(httpError: HttpErrorResponse) : string {

        console.error(httpError);
        var error = typeof httpError.error === 'string' ? JSON.parse(httpError.error) : null;
        return error ? error.message : 'Error desconocido';

    }

}
